import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createRequestPowerPlayerWindowOutbound } from '../api/outbound/commonOutbounds';
import { PowerPlayerBolt } from '../assets/powerPlayerBolt';
import { IconWithLabelDisplay } from '../components/iconWithLabelDisplay';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { SELF_PANEL_CONTENT_HOVER_COLOR } from '../styles/colors';
import { PanelItem } from './panelItem';
import { PowerPlayerStatusButtonPanelItem } from './powerPlayerStatusButtonPanelItem';
export const PowerPlayerPanelItem = ({ isPowerPlayer, isSelfPanel, powerPlayerBoltColor }) => {
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createRequestPowerPlayerWindowOutbound());
    }, [socketSend]);
    if (isPowerPlayer) {
        return (_jsx(PanelItem, { onClick: isSelfPanel ? onClick : undefined, hoverColor: isSelfPanel ? SELF_PANEL_CONTENT_HOVER_COLOR : undefined, children: _jsx(IconWithLabelDisplay, { icon: _jsx(PowerPlayerBolt, { color: powerPlayerBoltColor }), label: 'Power Player' }) }));
    }
    else {
        if (isSelfPanel) {
            return _jsx(PowerPlayerStatusButtonPanelItem, {});
        }
        else {
            return _jsx(PanelItem, { children: "Not a Power Player" });
        }
    }
};
